import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-faq-overview',
  templateUrl: './faq-overview.component.html',
  styleUrls: ['./faq-overview.component.scss']
})
export class FaqOverviewComponent implements OnInit {
  @Input() selectedSectionDetail: any;

  constructor() { }
  faqs;
  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

}
